module.exports = __webpack_public_path__ + "ceaae681249ad8b3ef449b56010f90c9.pdf";